export enum BlobEntityType {
  AssessmentReferral = 'AssessmentReferral',
  AssessmentRecommendation = 'AssessmentRecommendation',
  Attachment = 'Attachment',
  IntakePet = 'IntakePet',
  License = 'License',
  Pet = 'Pet',
  Question = 'Question',
  SalesItem = 'SalesItem',
  Signatures = 'Signatures',
  SMSAttachment = 'smsattachment',
  SMSPhoto = 'smsphoto',
}
